import { useEffect, useRef, useState } from "react";
import FrontPage from "./components/FrontPage";
import Infos from "./components/Infos";
import Footer from "./components/Footer";
import { useTheme } from "next-themes";
import Intro from "../../common/Intro";
import { fetchFilteredprojects, ProjectType } from "../../io/projects_api";
import Project from "./components/Project";
import Navbar from "../../common/Navbar";



const LandingPage = () => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const IMAGECOUNT = 360; // Adjust based on number of images
    const IMAGE_SWITCH = 100/(IMAGECOUNT-1)
    const [images, setImages] = useState<any>(null)
    const [currentPage, setCurrentPage] = useState<number>(1)

    const [canvWidth, setCanvWidth] = useState<number>(0)
    // const [canvHeight, setCanvHeight] = useState<number>(0)


    const theme = useTheme()
    const [projects, setProjects] = useState<ProjectType[]>([])
    const [videoEnded, setVideoEnded] = useState<number>(0)

    var perc = 0
    let image_urls = useRef<string[]>([]);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0 , behavior: "smooth"});
    };


    useEffect(() => {
        image_urls.current = Array.from({length: IMAGECOUNT}, (_, i) => (
            theme.theme === 'light' 
            ? `/background/crazy bg comp/crazy bg_${(''+(i)).padStart(5,'0')}.png`
            : `/background/black_comp_3/v2 42 black0${(''+(i)).padStart(3,'0')}.webp`
        ))
        setVideoEnded(0)
        scrollToTop()
        cacheImages(image_urls.current).then((cached_images) => {
            setImages(cached_images)
            setVideoEnded((v) => v + 1)
        })

        if(canvasRef.current){
            const ctx = canvasRef.current.getContext("2d")
            const img = new Image();
            img.src = image_urls.current[0]
            img.onload = () => {
                setCanvWidth(img.width * (theme.theme === "dark" ? 0.7 : 0.9))
                // setCanvHeight(img.height * (theme.theme === "dark" ? 0.7 : 0.9))
                ctx!.clearRect(0, 0, img.width, img.height);
                ctx!.drawImage(img, 0, 0, img.width, img.height);
            };
        }

    }, [theme.theme])

    useEffect(() => {
        updateScroll()
    // eslint-disable-next-line
    }, [videoEnded])


    const cacheImages = async(images: any) => {
            const promises = await images.map((src: string, i: number) => {
                return new Promise(function(resolve: any, reject: any): void{
                    const img = new Image();
                    img.src = src
                    img.decoding = 'sync'
                    img.onload = () => {
                        const loadBar = document.getElementById("loading")
                        loadBar!.innerHTML= "" + (Number(loadBar!.innerHTML) + 1)
                        loadBar!.style.width = Number(loadBar!.innerHTML)/360 *100+ "%"
                        resolve(img);
                    }
                })
            })

        const images_p = await Promise.all(promises)

        return images_p
    }


    const updateScroll = (e?: React.WheelEvent|React.UIEvent|any) => {
        // if(e){
            perc =(window.scrollY/(document.documentElement.scrollHeight - window.innerHeight) * 100) || 0
            if (perc <= 10){
                setCurrentPage(1)
            }
            else if(perc > 8 && perc < 60){
                setCurrentPage(2)
            }else if(perc >= 60 && perc < 90){
                setCurrentPage(3)
            }else{
                setCurrentPage(4)
            }
            let img_num = Math.floor(perc/IMAGE_SWITCH)
            if(img_num < 0){
                img_num = img_num * -1
            }else if(img_num > IMAGECOUNT){
                img_num = img_num - IMAGECOUNT
            }
            const ctx = canvasRef.current?.getContext("2d")
            try{
                const img = images[img_num]
                if(canvasRef.current){
                    canvasRef.current.width = img.width
                    canvasRef.current.height = img.height
                }
                ctx?.clearRect(0, 0, img.width, img.height);
                ctx?.drawImage(img, 0, 0, img.width, img.height);
            }catch(err){
                console.log(err)
            }
        // }else{
        //     const ctx = canvasRef.current!.getContext("2d")
        //     let img_num = 0
        //     try{
        //         const img = images[img_num]
        //         canvasRef.current!.width = img.width
        //         canvasRef.current!.height = img.height
        //         ctx!.clearRect(0, 0, img.width, img.height);
        //         ctx!.drawImage(img, 0, 0, img.width, img.height);
        //     }catch(err){
        //         console.log(err)
        //     }
        // }
    }

    useEffect(() => {
        setProjects(fetchFilteredprojects(''))
        window.addEventListener("scroll", updateScroll)

        return () => {
            window.removeEventListener("scroll", updateScroll);
        };
// eslint-disable-next-line
    }, [images])

    const [filter, setFilter] = useState<string>('')

    const changeFilter = (filter: string) => {
        setFilter(filter)
        setProjects(fetchFilteredprojects(filter))
        updateScroll()
    }

    return(
        <>
            <div className={`fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black -z-20`}>
                <div>
                    <canvas ref={canvasRef} style={{width: canvWidth, aspectRatio: "16/9"}} className="max-w-full md:max-w-max max-h-full"/>
                </div>
            </div>
            {

                videoEnded >= 1?
                    <div 
                    // onWheel={(e) => updateScroll(e)} onTouchMove={(e) => {
                    //     updateScroll(e)
                    //     }}
                        >
                    <div className="w-full flex flex-col gap-12 xl:gap-32">
                        <FrontPage changeFilter={changeFilter}/>
                        <div className="w-full px-4 md:px-10 lg:px-24 xl:px-32" id="projects">
                            <div className="w-full gap-4 lg:gap-8 xl:gap-12 flex md:justify-start justify-around text-sm md:text-xl xl:text-3xl text-gray py-4 lg:py-8 cursor-base z-50">
                                <div className={`hover:text-white ${filter === '' ? 'text-white' : 'text-gray'}`} onClick={() => changeFilter("")}>ALL</div>
                                <div className={`hover:text-white ${filter === 'CORPORATE' ? 'text-white' : 'text-gray'}`} onClick={() => changeFilter("CORPORATE")}>CORPORATE</div>
                                <div className={`hover:text-white ${filter === 'MOTION' ? 'text-white' : 'text-gray'}`} onClick={() => changeFilter("MOTION")}>MOTION</div>
                                <div className={`hover:text-white ${filter === 'GAME' ? 'text-white' : 'text-gray'}`} onClick={() => changeFilter("GAME")}>GAME</div>
                                <div className={`hover:text-white ${filter === 'OTHER' ? 'text-white' : 'text-gray'}`} onClick={() => changeFilter("OTHER")}>OTHER</div>
                            </div>
                            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-4 md:gap-x-8 xl:gap-x-16 gap-y-12 md:gap-y-20 xl:gap-y-24">
                                {
                                    projects.map((project, index) => {
                                        return <Project key={index} project={project} />
                                    })
                                }               
                            </div>
                        </div> 
                        <Infos />
                        <Footer />
                        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage}/>
                    </div>
                </div>
                :
            <>
                <Intro />
                <div className='w-screen bottom-12 fixed z-20 flex justify-center h-1'>
                    <div className='flex h-full bg-gray w-1/4 rounded-full'>
                        <div id='loading' className='h-full rounded-full bg-green-400 text-transparent'>0</div>
                    </div>
                </div>
            </>
            }
        </>
    )
}

export default LandingPage;